/*
======================= START OF LICENSE NOTICE =======================
  Copyright (C) 2024 yanto. All Rights Reserved

  NO WARRANTY. THE PRODUCT IS PROVIDED BY DEVELOPER "AS IS" AND ANY
  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL DEVELOPER BE LIABLE FOR
  ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
  DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
  INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER
  IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
  OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE PRODUCT, EVEN
  IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
======================== END OF LICENSE NOTICE ========================
  Primary Author: yanto

*/
/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import axios from "axios"
import logging from "../utils/logger";

const initializeApp = async () => {
    await checkSession()
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code
        logging.info("Running in development mode");
    } else {
        // Prod build code
        //  console.log("Running in production mode");
        // Removing console.log from prod
        console.log = () => {
        };


        // init analytics here
    }

}

async function checkSession() {
    try {
        const session = await getSessionFromLocalStorage();

        if (!session) {
            await removeSessionFromLocalStorage();
        }

    } catch (error) {
        logging.error('Error checking session:', error);
    }
}

async function getSessionFromLocalStorage() {
    return new Promise((resolve, reject) => {
        try {
            const session = localStorage.getItem('session');
            resolve(session);
        } catch (error) {
            reject(error);
        }
    });
}

async function removeSessionFromLocalStorage() {
    return new Promise((resolve, reject) => {
        try {
            localStorage.removeItem('session');
            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

export default initializeApp
